import { Locale } from 'dayjs/locale/eo';

const ZuLocale: Locale = {
    name: 'zu-zu',
    weekdays: ['ISonto', 'UMsombuluko', 'ULwesibili', 'ULwesithathu', 'ULwesine', 'ULwesihlanu', 'UMgqibelo'],
    weekdaysShort: ['Xon', 'Mso', 'Bil', 'Tha', 'Sin', 'Hla', 'Mgq'],
    weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    months: [
        'Januwari',
        'Februwari',
        'Mashi',
        'Ephreli',
        'Meyi',
        'Juni',
        'Julayi',
        'Agasti',
        'Septhemba',
        'Okthoba',
        'Novemba',
        'Disemba',
    ],
    monthsShort: ['Jan', 'Feb', 'Mas', 'Eph', 'Mey', 'Jun', 'Jul', 'Aga', 'Sep', 'Okta', 'Nov', 'Dis'],
    ordinal: (n) => `${n}º`,
    formats: {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    },
    relativeTime: {
        future: 'olandelayo %s',
        past: '%s edlule',
        s: 'imizuzwana embalwa',
        m: 'umzuzu',
        mm: '%d imizuzu',
        h: 'ihora',
        hh: '%d amahora',
        d: 'usuku',
        dd: '%d izinsuku',
        M: 'ngenyanga',
        MM: '%d izinyanga',
        y: 'unyaka',
        yy: '%d iminyaka',
    },
};

export default ZuLocale;
